module.exports = __webpack_public_path__ + "static/media/who-20.1688855d.jpg";